/* eslint-disable */

/**
 * 该文件为脚本自动生成文件，请勿随意修改。如需修改请联系 PMC
 * */

import { TreeOptionData, TreeKeysType } from '../common/common';

export interface TdTreeSelectProps<DataOption extends TreeOptionData = TreeOptionData> {
  /**
   * 自定义选中值，优先级高于 `value`
   */
  customValue?: {
    type: null;
    value?: TreeSelectValue;
  };
  /**
   * 高度，默认单位为 px
   * @default 336
   */
  height?: {
    type: null;
    value?: string | number;
  };
  /**
   * 用来定义 `value / label / disabled / children` 在 `options` 数据中对应的字段别名，示例：`{ value: 'key', label: 'name', children: 'list' }`
   */
  keys?: {
    type: ObjectConstructor;
    value?: TreeKeysType;
  };
  /**
   * 是否允许多选
   * @default false
   */
  multiple?: {
    type: BooleanConstructor;
    value?: boolean;
  };
  /**
   * 选项
   * @default []
   */
  options?: {
    type: ArrayConstructor;
    value?: Array<DataOption>;
  };
  /**
   * 选中值
   */
  value?: {
    type: null;
    value?: TreeSelectValue;
  };
  /**
   * 选中值，非受控属性
   */
  defaultValue?: {
    type: null;
    value?: TreeSelectValue;
  };
}

export type TreeSelectValue = string | number | Array<TreeSelectValue>;
